// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GG-z","hovered":"HG-z","hoverImage":"IG-z","mainImage":"JG-z","imageNoBackground":"KG-z","fullSizeImage":"LG-z"};